module.exports = __webpack_public_path__ + "static/img/应用效果1-纯环视.5fa6e73.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/type1-1/应用效果1-纯环视.png
// module id = oMJ2
// module chunks = 0